import { render, staticRenderFns } from "./FormCliente.vue?vue&type=template&id=23e51eb5&scoped=true"
import script from "./FormCliente.vue?vue&type=script&lang=js"
export * from "./FormCliente.vue?vue&type=script&lang=js"
import style0 from "./FormCliente.vue?vue&type=style&index=0&id=23e51eb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e51eb5",
  null
  
)

export default component.exports